module.exports = __webpack_public_path__ + "static/media/briefcase.155997e1.svg";